module.exports = __webpack_public_path__ + "static/media/speed-typer.46bcf681.png";